import { jwtDecode } from 'jwt-decode';

export const isTokenExpired = (token: string) => {
  if (token === '') return true;

  const decoded = jwtDecode(token);
  console.log('!! token decoded = ', decoded);
  return new Date().getTime() / 1000 > (decoded.exp ?? 0);
};
